import { combineReducers } from "redux";
import  dataModule  from "./dataModule";

export default combineReducers({ dataModule });